﻿$(document).on('dblclick', '.rdCheck', function () {
    if (this.checked) {
        $(this).prop('checked', false);
    }
});
$(document).ready(function () {
    var callbacks = {
        OnSuccess: OnParticipantSuccess,
        OnFailure: OnFailure,
    };
    var config = new PostConfiguration();
    config.url = localStorage.getItem("fetchURL") + '/api/Participant/GetAllParticipantFieldsMetas';

    sendRequest(callbacks, config, "");
});
function OnParticipantSuccess(response) {
    LoadParticpantControls(response);

  //below 2 line added for temporary Mandatory Terms And Conditions requirement from TE
  if ($.isFunction(window.MandatoryTermsAndConditions))
    MandatoryTermsAndConditions();
}

function LoadParticpantControls(PARTICIPANT_FIELDS_DTO_LIST) {
    for (var i = 0; i < PARTICIPANT_FIELDS_DTO_LIST.length; i++) {
        if (PARTICIPANT_FIELDS_DTO_LIST[i].FIELD_TYPE == 'TEXT') {
            $('.FieldsSection').append('<tr class="FieldsSectionRow"><td class="txt_cell"><b>' +
                PARTICIPANT_FIELDS_DTO_LIST[i].FIELD_DISPLAY_TEXT + '</b></td><td class="txtbox">' + CreateControl(PARTICIPANT_FIELDS_DTO_LIST[i]) + '</span></td></tr>');
        } else {
          $('.FieldsSection').append('<tr class="FieldsSectionRow RadioField" id="' + PARTICIPANT_FIELDS_DTO_LIST[i].FIELD_CODE + '"><td class="rd_cell"><b>' +
                PARTICIPANT_FIELDS_DTO_LIST[i].FIELD_DISPLAY_TEXT + '</b></td><td class="rd_input_cell" style="padding-top:20px;">' + CreateControl(PARTICIPANT_FIELDS_DTO_LIST[i]) + '</td></tr>');
        }
       }

    function CreateControl(PARTICIPANT_FIELDS_DTO) {
        if (PARTICIPANT_FIELDS_DTO.FIELD_TYPE == 'TEXT') {
            return '<br><br><input id="FIELD_' + PARTICIPANT_FIELDS_DTO.FIELD_NO +
                '" data-id="' + PARTICIPANT_FIELDS_DTO.FIELD_NO +
                '" value="' + '" class="txt-class form-control" type="text" >';
        }

        if (PARTICIPANT_FIELDS_DTO.FIELD_TYPE == 'RADIO') {
            return '<table class="radiolist" >' +
                CreateRadioOption(PARTICIPANT_FIELDS_DTO) + '</table>';
        }
        if (PARTICIPANT_FIELDS_DTO.FIELD_TYPE == 'CHECKBOX') {
            return '<table class="checkboxlist" > <tr>' +
                CreateCheckBoxOption(PARTICIPANT_FIELDS_DTO) + '</tr></table>';
        }

        if (PARTICIPANT_FIELDS_DTO.FIELD_TYPE == 'DROPDOWN') {
            return '<select class="select-box" id="FIELD_' + PARTICIPANT_FIELDS_DTO.FIELD_NO
                + '" data-id="' + PARTICIPANT_FIELDS_DTO.FIELD_NO + '">' +
                '<option value="">--Please Select--</option>' +
                CreateDropdownBoxOption(PARTICIPANT_FIELDS_DTO) +
                '<select>';
        }
        return PARTICIPANT_FIELDS_DTO.FIELD_TYPE;
    }
}

function CreateRadioOption(PARTICIPANT_FIELDS_DTO) {
    var control = '';
    var array = PARTICIPANT_FIELDS_DTO.FIELD_OPTIONS.split('|');
    for (var i = 0; i < array.length; i++) {
        control += '<tr><td><input id="FIELD_' + PARTICIPANT_FIELDS_DTO.FIELD_NO + '_' + i
            + '" data-id="' + PARTICIPANT_FIELDS_DTO.FIELD_NO
            + '" type="radio" name="FIELD_' + PARTICIPANT_FIELDS_DTO.FIELD_NO +
            '" class="rdCheck" value="' + array[i] + '"' + '>';
        control += '<span style="padding-left:3px;" for="FIELD_' + PARTICIPANT_FIELDS_DTO.FIELD_NO + '_' + i + '">'
            + array[i] + '</span></td></tr>';
    }
    return control;
}
function CreateCheckBoxOption(PARTICIPANT_FIELDS_META) {
    var control = '';
    var array = PARTICIPANT_FIELDS_META.FIELD_OPTIONS.split('|');
    for (var i = 0; i < array.length; i++) {
      control += '<tr><td> <input id="FIELD_' + PARTICIPANT_FIELDS_META.FIELD_NO + "_" + i
        + '" data-id="' + PARTICIPANT_FIELDS_META.FIELD_NO
        + '" type="checkbox" name="FIELD_' + PARTICIPANT_FIELDS_META.FIELD_NO + "_" + i + '" value="' + array[i] + '"> ';
      control += '<span style="padding-left:3px;line-height: 0px;" for="FIELD_' + PARTICIPANT_FIELDS_META.FIELD_NO + '_' + i + '">'
        + array[i].replace(/&lt;/g, '<').replace(/&gt;/g, '>') + '</span></td></tr>';
    }
    return control;
}
function CreateDropdownBoxOption(PARTICIPANT_FIELDS_DTO) {
    var control = '';
    var array = PARTICIPANT_FIELDS_DTO.FIELD_OPTIONS.split('|');
    for (var i = 0; i < array.length; i++) {
        control += '<option'
            + ' value="' + array[i] + '">' + array[i] + '</option>';
    }
    return control;
}
function CreateTextOption(PARTICIPANT_FIELDS_DTO) {
    var control = '';
    var array = PARTICIPANT_FIELDS_DTO.FIELD_OPTIONS.split('|');
    for (var i = 0; i < array.length; i++) {
        control += array[i];
    }
    return control;
}



